module.exports = __webpack_public_path__ + "pc/img/rec_21.dee326aa.svg";